module.exports = __webpack_public_path__ + "img/rec-08.26c1452f.jpg";